
































import { Vue, Component, Prop, Model } from 'vue-property-decorator';

import BaseModal from './BaseModal.vue';
import BaseButton from '@/components/buttons/BaseButton.vue';

@Component({
    components: {
        BaseModal,
        BaseButton,
    }
})
export default class ConfirmModal extends Vue {
    @Model('update:open' ,{ required: true }) readonly  open!: boolean
    @Prop({ default: '' }) title!: string
    @Prop({ default: 'Да' }) confirmText!: string
    @Prop({ default: 'Отмена' }) cancelText!: string

    changeModalVisibility(open: boolean) {
        const event = open ? 'open' : 'close';

        this.$emit(event);
        this.$emit('update:open', open);
    }

    confirm() {
        this.$emit('confirm');
        this.changeModalVisibility(false);
    }

    cancel() {
        this.$emit('cancel');
        this.changeModalVisibility(false);
    }
}
